import script from "./univModal.vue?vue&type=script&setup=true&lang=js"
export * from "./univModal.vue?vue&type=script&setup=true&lang=js"

import "./univModal.vue?vue&type=style&index=0&id=0080dc2e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0080dc2e"]])

export default __exports__